import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import GameActions from '../../../redux/Game/actions';
import classes from '../../../data/classes';
import BaseSelector from '../../baseSelector';
import BaseInput from '../../baseInput';
import classTypes from '../../../data/types/classes';

const Player = styled.span`
  display: flex;
  align-self: center;
  margin-top: 20px;
`;
const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 15px;
`;

const CharacterSelector = ({ player, value, classValue }) => {
  const dispatch = useDispatch();

  const handleChange = (data) => {
    dispatch(
      GameActions.setPlayedClass({ player, playedClass: data.target.value }),
    );
  };

  const handleNameChange = (data) => {
    dispatch(
      GameActions.setDisplayName({ player, displayName: data.target.value }),
    );
  };

  const label = player + 1;

  const {
    wizard,
    necromancer,
    barbarian,
    crusader,
    monk,
    witchDoctor,
    demonHunter,
  } = classTypes;

  const options = [
    { name: 'Random', value: 'RANDOM' },
    { name: classes[wizard].displayName, value: classes[wizard].class },
    {
      name: classes[necromancer].displayName,
      value: classes[necromancer].class,
    },
    { name: classes[barbarian].displayName, value: classes[barbarian].class },
    { name: classes[crusader].displayName, value: classes[crusader].class },
    { name: classes[monk].displayName, value: classes[monk].class },
    {
      name: classes[witchDoctor].displayName,
      value: classes[witchDoctor].class,
    },
    {
      name: classes[demonHunter].displayName,
      value: classes[demonHunter].class,
    },
  ];

  return (
    <Container>
      <Player>{label}</Player>
      <BaseInput
        label="Player"
        onChange={handleNameChange}
        width="200px"
        nomargin
        value={value}
      />
      <BaseSelector
        options={options}
        label="Class"
        id={'P' + player + 'characterSelector'}
        onChange={handleChange}
        value={classValue}
      />
    </Container>
  );
};

CharacterSelector.propTypes = {
  player: PropTypes.number,
  value: PropTypes.string,
  classValue: PropTypes.string,
};

export default CharacterSelector;
